import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';

export enum DeliveryNotePreferredWording {
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  SERVICE_CONFIRMATION = 'SERVICE_CONFIRMATION',
  SERVICE_CONFIRMATION_AND_DELIVERY_NOTE = 'SERVICE_CONFIRMATION_AND_DELIVERY_NOTE',
}

const DeliveryNotePreferredWordingValues = Object.values(
  DeliveryNotePreferredWording
);

export type DeliveryNotePreferredWordingPickerProps = {
  value: DeliveryNotePreferredWording;
  onChange: (value: DeliveryNotePreferredWording) => void;
};

export function DeliveryNotePreferredWordingPicker(
  props: DeliveryNotePreferredWordingPickerProps
) {
  const { value: valueProp, onChange } = props;

  const { t } = useTranslation();

  const options = useMemo(() => {
    return DeliveryNotePreferredWordingValues.map((value) => {
      return {
        id: value,
        name: t(`DELIVERY_NOTE_PREFERRED_WORDING.${value}`),
      };
    });
  }, [t]);

  const value = useMemo(() => {
    return options.find((item) => item.id === valueProp);
  }, [valueProp, options]);

  return (
    <FixedDataPicker
      value={value}
      dataSet={options}
      multiple={false}
      clearable={false}
      onChange={(value) => {
        onChange(value.id);
      }}
    />
  );
}
